class YoutubePlayer {
    constructor(_option){
        if(!_option && typeof(_option) !== 'object') {
            throw new TypeError("Player module need object type option");
        }

        if(_option && !document.querySelector(_option.selector)) {
            throw new TypeError(`no ${_option.selector} DOM Element`);
        }

        this.context = $(_option.selector);

        this.player = null;

        this.config = $.extend({
            fps: 60,
            videoId: '',
            playerId: '',
            mute: false,
            autoPlay: false,
            loop: false,
            controls: false,
            coverClick: false
        }, _option);

        this.config.playerId = `${_option.selector.replace(/^#/, '')}__${this.config.videoId}`;

        this.state = {
            isPlay: false,
            isControlShow: true,
            animationFrame: 0,
            timer: null,
            isReady: false,
            isTouchInit: false
        };

        this.template = {
            player: `<div id="${this.config.playerId}"></div>`,
            controls: `<div class="player__controls">
							<div class="player__progress">
								<div class="player__progress-bar"></div>
					   		</div>
							<button type="button" class="player__play player__play_show">재생</button>
							<button type="button" class="player__pause">정지</button>
					   </div>`,
            cover: `<div class="player__cover"></div>`,
            poster: `<div class="player__poster" style="background:url('https://img.youtube.com/vi/${this.config.videoId}/sddefault.jpg') no-repeat 50% 50%"></div>`
        };

        this.DOM = {
            controls: null,
            progress: null,
            progressBar: null,
            poster: null,
            play: null,
            pause: null
        };

        this.dimension = {
            progress: 0,
            progressLeft: 0,
        };

        this._handleStateChange = this._handleStateChange.bind(this);
        this._handleReady = this._handleReady.bind(this);
        this._animationFrame = this._animationFrame.bind(this);
    }

    init(){
        if(window.YT && window.YT.Player) {
            this._setPlayer();
            return;
        }

        if(!window.loadYoutubeApi) {
            window.loadYoutubeApi = true;
            const tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }

        let check = setInterval(() =>{
            if(window.YT && window.YT.Player) {
                clearInterval(check);
                this._setPlayer();
            }
        }, 200);

    }

    _setPlayer(){
        this._renderPlayer();

        this.player = new window.YT.Player(this.config.playerId, {
            width: '100%',
            height: '100%',
            videoId: this.config.videoId,
            playerVars: {
                modestbranding: 1,
                rel: 0,
                showinfo: 0,
                controls: 0,
                playsinline: 1,
                autoplay: this.config.autoPlay === true ? 1 : 0,
                loop: this.config.loop === true ? 1 : 0,
                playlist: this.config.loop === true ? this.config.videoId : ''
            },
            events: {
                onStateChange: this._handleStateChange,
                onReady: this._handleReady
            }
        });

        this._detectDom();
        this._detectDimension();
        this._setMovieSize();
    }

    _renderPlayer(){
        this.context.append(this.template.player);
        this.context.append(this.template.poster);
        this.context.append(this.template.cover);
        this.config.controls && this.context.append(this.template.controls);
    }

    _detectDom(){
        this.DOM.poster = this.context.find('.player__poster');

        if(this.config.controls) {
            this.DOM.controls = this.context.find('.player__controls');
            this.DOM.progress = this.context.find('.player__progress');
            this.DOM.progressBar = this.context.find('.player__progress-bar');
            this.DOM.play = this.context.find('.player__play');
            this.DOM.pause = this.context.find('.player__pause');
        }
    }

    _detectDimension(){
        if(this.config.controls) {
            this.dimension.progress = this.DOM.progress.width();
            this.dimension.progressLeft = this.DOM.progress[0].getBoundingClientRect().left;
        }
    }

    _setMovieSize(){
        let contextWidth = this.context[0].offsetWidth;
        let contextHeight = this.context[0].offsetHeight;
        let setWidth = 0;
        let setHeight = 0;

        if((contextWidth / contextHeight) < (1280 / 720)) {
            setWidth = contextHeight * 1280 / 720;
            setHeight = contextHeight;
        } else {
            setWidth = contextWidth;
            setHeight = contextWidth * 720 / 1280;
        }

        $(`#${this.config.playerId}`).css({
            width: setWidth,
            height: setHeight
        });
    }

    _setEvent(){
        if(this.config.controls) {
            this.context.on('click', '.player__play', () =>{
                this.play();
            });

            this.context.on('click', '.player__pause', () =>{
                this.pause();
            });

            this.context.on('click', '.player__progress', (e) =>{
                this.seek((1 - (this.dimension.progress - (e.clientX - this.dimension.progressLeft)) / this.dimension.progress) * this.player.getDuration());

                if(!this.state.isPlay) {
                    this._handleProgressUpdate((e.clientX - this.dimension.progressLeft) / this.dimension.progress);
                }
            });

            this.context.on('mousemove', (e) =>{
                if(!this.state.isPlay) return;

                if(e.target === this.DOM.progress[0] || e.target === this.DOM.progressBar[0] || e.target === this.DOM.play[0] || e.target === this.DOM.pause[0]) return;

                if(!this.state.isControlShow) {
                    this.state.isControlShow = true;

                    this.DOM.controls.removeClass('player__controls_hide');
                } else {
                    clearTimeout(this.state.timer);

                    this.state.timer = setTimeout(() =>{
                        if(!this.state.isPlay) return;
                        this.state.isControlShow = false;

                        this.DOM.controls.addClass('player__controls_hide');
                    }, 1000);
                }
            });

            this.context.on('mouseover', '.player__controls', () =>{
                if(!this.state.isPlay) return;
                clearTimeout(this.state.timer);
                this.DOM.controls.removeClass('player__controls_hide');
            });

            this.context.on('mouseout', '.player__controls', () =>{
                if(!this.state.isPlay) return;

                clearTimeout(this.state.timer);

                this.state.timer = setTimeout(() =>{
                    if(!this.state.isPlay) return;
                    this.state.isControlShow = false;

                    this.DOM.controls.addClass('player__controls_hide');
                }, 1000);
            });
        }

        if(this.config.coverClick) {
            this.context.on('click', '.player__cover', () =>{
                this.state.isPlay ? this.pause() : this.play();
            });
        }

        $(window).on('resize.player', () =>{
            this.config.controls && this._detectDimension();
            this._setMovieSize();
        });
    }

    _handleReady(){
        this.state.isReady = true;
        $(window).trigger(`canplay.${this.config.selector.replace(/^([#.])/, '')}`);
        $(window).trigger(`canplay.${this.config.videoId}`);

        this._setMovieSize();
        this._setEvent();
        $('#' + this.config.playerId).addClass('isReady');

        if(this.config.mute) {
            this.mute();
        }
    }

    _handleStateChange(e){
        switch(e.data) {
            case YT.PlayerState.PLAYING:
                if(this.state.isPlay) return;
                this.state.isPlay = true;

                if(this.config.controls) {
                    this.DOM.play.removeClass('player__play_show');
                    this.DOM.pause.addClass('player__pause_show');
                    this.state.timer = setTimeout(() =>{
                        if(!this.state.isPlay) return;
                        this.DOM.controls.addClass('player__controls_hide');
                    }, 1000);

                    this.state.isControlShow = false;
                }

                this._animationFrame(this.state.animationFrame, this._handlePlayUpdate, e);

                this.DOM.poster.fadeOut();
                break;

            case YT.PlayerState.PAUSED:
                cancelAnimationFrame(this.state.animationFrame);
                this.state.isPlay = false;

                if(this.config.controls) {
                    this.DOM.play.addClass('player__play_show');
                    this.DOM.pause.removeClass('player__pause_show');
                    this.DOM.controls.removeClass('player__controls_hide');

                    this.state.isControlShow = true;
                }
                break;

            case YT.PlayerState.CUED:
                cancelAnimationFrame(this.state.animationFrame);
                this.state.isPlay = false;

                if(this.config.controls) {
                    this.DOM.play.addClass('player__play_show');
                    this.DOM.pause.removeClass('player__pause_show');
                    this.DOM.controls.removeClass('player__controls_hide');

                    this.state.isControlShow = true;
                }

                this.DOM.poster.show();

                if(this.config.controls) {
                    this._handleProgressUpdate(0, 0);
                }

                break;

            case YT.PlayerState.ENDED:
                cancelAnimationFrame(this.state.animationFrame);
                this.state.isPlay = false;

                if(this.config.controls) {
                    this.DOM.play.addClass('player__play_show');
                    this.DOM.pause.removeClass('player__pause_show');
                    this.DOM.controls.removeClass('player__controls_hide');

                    this.state.isControlShow = true;
                }

                this.DOM.poster.show();

                $(window).trigger(`end.${this.config.selector.replace(/^#/, '')}`);

                break;
        }
    }

    _handlePlayUpdate(e){
        this.config.controls && this._handleProgressUpdate(e.target.getCurrentTime() / this.player.getDuration());
    }

    _handleProgressUpdate(bar){
        this.DOM.progressBar.css({
            'transform': `scale(${bar > 1 ? 1 : bar}, 1)`
        });
    }

    _animationFrame(reqId, doFunc, e){
        let loop = () =>{
            doFunc.call(this, e);
            this.state.isPlay && (reqId = requestAnimationFrame(loop));
        };

        loop();
    };

    setTouchInit(){
        this.state.isTouchInit = true;
    }

    play(){
        this.state.isReady && !this.state.isPlay && this.player.playVideo();
    }

    stop(){
        this.player.stopVideo();
    }

    pause(){
        this.player.pauseVideo();
    }

    mute(){
        this.player.mute();
    }

    unMute(){
        this.player.unMute();
    }

    seek(t){
        this.player.seekTo(t);
    }

}

export default YoutubePlayer;